var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Button, Column, Columns, Flex, Text } from '@homeexchange/design';
import React, { useCallback, useMemo, useState } from 'react';
import i18n from '../../../i18n';
import Analytics from '../../../utils/analytics';
import styles from './results.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { toggleFavorite } from '../../../actions/homeFavorites';
import { useDevice, useWindowSize } from '@homeexchange/shared';
import { HomeCard } from './homecard';
import Utils from '../../../utils/utils';
import clx from 'classnames';
import { SavedSearchModal } from '.';
export function Results(_a) {
    var results = _a.results, user = _a.user, homeRollOver = _a.homeRollOver, homeRollOut = _a.homeRollOut, isLogged = _a.isLogged, push = _a.push, locationQuery = _a.locationQuery, onPushAlert = _a.onPushAlert, _b = _a.hideFixedDates, hideFixedDates = _b === void 0 ? false : _b, searchFilters = _a.searchFilters, trackingEvent = _a.trackingEvent, origin = _a.origin;
    var locale = i18n.language;
    var dispatch = useDispatch();
    var isMobile = useDevice().isMobile;
    var _c = useState(false), isOpen = _c[0], setIsOpen = _c[1];
    var initialHomeFavorites = useSelector(function (state) {
        return state.homeFavorites;
    });
    var width = useWindowSize().width;
    var isLargeDesktop = width >= 1560;
    var _d = useState(initialHomeFavorites), homeFavorites = _d[0], setHomeFavorites = _d[1];
    var _e = useState(false), isCreatingAlert = _e[0], setIsCreatingAlert = _e[1];
    var _f = useState(null), createdAlert = _f[0], setCreatedAlert = _f[1];
    var isUserCollection = user === null || user === void 0 ? void 0 : user.get('is_he_collection');
    var handleToggleFavorite = useCallback(function (homeId) {
        dispatch(toggleFavorite(homeId, homeFavorites));
        if (homeFavorites.includes(homeId)) {
            var updatedFavorites = homeFavorites.filter(function (id) { return id !== homeId; });
            setHomeFavorites(updatedFavorites);
            dispatch({
                type: 'REMOVE_HOME_FAVORITE',
                homeFavorites: homeId
            });
        }
        else {
            var updatedFavorites = __spreadArray(__spreadArray([], homeFavorites, true), [homeId], false);
            setHomeFavorites(updatedFavorites);
            dispatch({
                type: 'ADD_HOME_FAVORITE',
                homeFavorites: homeId
            });
        }
    }, [dispatch, homeFavorites]);
    var handleCreateAlert = function () {
        if (!onPushAlert)
            return;
        Analytics.trackGTM('SearchResults', {
            event_data: {
                action: 'click',
                area: 'search',
                text: 'save_this_destination',
                origin: 'search_results_home_cards',
                search_value: locationQuery
            }
        });
        setIsCreatingAlert(true);
        onPushAlert()
            .then(function (result) {
            setIsCreatingAlert(false);
            setIsOpen(true);
            setCreatedAlert(result);
        })
            .catch(function (error) {
            console.error('Failed to create alert:', error);
            setIsCreatingAlert(false);
        });
    };
    var groupedResults = useMemo(function () {
        var resultsCopy = __spreadArray([], results, true);
        var alertPushPosition = isMobile ? 8 : 19;
        var referralPushPosition = 3;
        var shouldInsertPush = push && (push.type === 'alert' || push.type === 'referral');
        if (shouldInsertPush && results.length > 0) {
            if (push.type === 'referral') {
                if (results.length >= referralPushPosition) {
                    resultsCopy.splice(referralPushPosition, 0, { isPush: true, type: 'referral' });
                }
                else {
                    resultsCopy.push({ isPush: true, type: 'referral' });
                }
            }
            else if (push.type === 'alert') {
                if (results.length >= alertPushPosition) {
                    resultsCopy.splice(alertPushPosition, 0, { isPush: true, type: 'alert' });
                }
                else {
                    resultsCopy.push({ isPush: true, type: 'alert' });
                }
            }
        }
        var grouped = [];
        for (var i = 0; i < resultsCopy.length; i += isLargeDesktop ? 3 : 2) {
            grouped.push(resultsCopy.slice(i, i + (isLargeDesktop ? 3 : 2)));
        }
        if (results.length === 0 && shouldInsertPush) {
            grouped.push([{ isPush: true, type: push.type }]);
        }
        return grouped;
    }, [results, push, isMobile]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles['results-container'] }, groupedResults.map(function (group, groupIndex) { return (React.createElement(Columns, { key: "group-".concat(groupIndex) }, group.map(function (result, resultIndex) {
            var _a;
            if ('isPush' in result) {
                return (React.createElement(Column, { size: isLargeDesktop ? 4 : 6, key: "push-".concat(groupIndex, "-").concat(resultIndex), className: styles['results-column'] },
                    React.createElement("div", { className: clx(styles['box-push'], (_a = {},
                            _a[styles['box-push-collection']] = isUserCollection,
                            _a)) }, result.type === 'alert' ? (React.createElement(Flex, { direction: "column", gap: "4", alignItems: "center", justifyContent: "center", isFullHeight: true },
                        React.createElement("img", { src: "".concat(Utils.getCloudfrontDomain(), "/images/website/migration/search/alert").concat(isUserCollection ? '-collection' : '', ".svg"), alt: "Alert" }),
                        !isUserCollection && (React.createElement(Text, { isBold: true }, i18n.t('user:banner_saveSearch_title'))),
                        React.createElement(Text, { center: true }, i18n.t('search:no-results.alert-body', {
                            location: locationQuery
                        })),
                        React.createElement(Button, { color: "tertiary", isLoading: isCreatingAlert, onClick: handleCreateAlert }, i18n.t('search:alert.save_alert')))) : (React.createElement(Flex, { direction: "column", gap: "4", alignItems: "center", justifyContent: "center", isFullHeight: true },
                        React.createElement("img", { src: "".concat(Utils.getCloudfrontDomain(), "/images/website/migration/search/megaphone").concat(isUserCollection ? '-collection' : '', ".svg"), alt: "Referral", width: 95 }),
                        React.createElement(Text, { isBold: true }, i18n.t('search:push.sponsorship.title')),
                        React.createElement(Text, { center: true }, i18n.t('search:push.sponsorship.text')),
                        React.createElement(Button, { color: "tertiary", href: i18n.t('url:sponsorship'), target: "_blank", rel: "noopener noreferrer" }, i18n.t('common:invite-friends')))))));
            }
            return (React.createElement(Column, { size: isLargeDesktop ? 4 : 6, key: result.attributes.id, className: styles['results-column'] },
                React.createElement("div", { onMouseEnter: function () { return homeRollOver(result.attributes.homeId); }, onMouseLeave: homeRollOut },
                    React.createElement(HomeCard, { result: result, locale: locale, isLogged: isLogged, isUserCollection: isUserCollection, homeFavorites: homeFavorites, handleToggleFavorite: handleToggleFavorite, format: "search", hideFixedDates: hideFixedDates, user: user, searchFilters: searchFilters, trackingEvent: trackingEvent, origin: origin }))));
        }))); })),
        React.createElement(SavedSearchModal, { isOpen: isOpen, onClose: function () { return setIsOpen(false); }, createdAlert: createdAlert })));
}
